const defaultSteps = [
    { key: "Anfrage", label: "Anfrage wird bearbeitet", hint: "Termine abstimmen" },
    { key: "Angebot", label: "Angebot wird erstellt", hint: "Termine abstimmen" },
    { key: "AngebotAngenommen", label: "Angebot angenommen", hint: "Termine abstimmen" },
    { key: "Bestellung", label: "Material ist bestellt", hint: "Auftrag bestätigt" },
    { key: "Terminanfrage", label: "Terminanfrage", hint: "Fertigung & Zuschnitt" },
    { key: "Terminiert", label: "Terminiert", hint: "Einbau oder Abholung" },
];

const StatusTimeline = ({ currentStatus, steps = defaultSteps }) => {
    const normalizedSteps = steps && steps.length > 0 ? steps : defaultSteps;
    const currentIndex = normalizedSteps.findIndex((step) => step.key === currentStatus);
    const activeIndex = currentIndex >= 0 ? currentIndex : 0;

    return (
        <div className="flex flex-col gap-5">
            <div className="rounded-2xl border border-slate-100 bg-slate-50/60 p-4 md:p-5 overflow-x-auto">
                <div className="flex items-start min-w-max">
                    {normalizedSteps.map((step, index) => {
                        const isPast = index < activeIndex;
                        const isActive = index === activeIndex;
                        const isLast = index === normalizedSteps.length - 1;
                        const isConnectorDone = index < activeIndex;

                        return (
                            <div key={step.key} className="relative flex-1 min-w-[150px] px-2 md:px-3">
                                {!isLast && (
                                    <div
                                        className={`absolute top-6 left-1/2 right-[-50%] h-[2px] z-0 transition ${isConnectorDone ? "bg-blue-300" : "bg-slate-200"
                                            }`}
                                    />
                                )}

                                <div className="relative z-10 flex justify-center">
                                    <div
                                        className={`relative z-10 w-12 h-12 rounded-full flex items-center justify-center border text-sm font-semibold transition ${isActive
                                            ? "bg-blue-600 text-white border-blue-600 shadow-lg shadow-blue-200"
                                            : isPast
                                                ? "bg-blue-100 text-blue-700 border-blue-200"
                                                : "bg-slate-100 text-slate-500 border-slate-200"
                                            }`}
                                    >
                                        {isPast ? "✓" : index + 1}
                                    </div>
                                </div>

                                <div className="mt-3 text-center px-1">
                                    <p className={`text-sm md:text-[15px] font-semibold leading-tight ${isActive ? "text-blue-700" : "text-slate-800"}`}>
                                        {step.label}
                                    </p>
                                    {/* {step.hint && <p className="text-xs text-slate-500">{step.hint}</p>} */}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default StatusTimeline;
